// Both arms use the claim-minting Worker. Native Omnisend forms cannot replace this.
export const EXPERIMENT = 'pt_free_dctl_offer_v1';
export const OFFERS = Object.freeze({
  trio: { tag: 'free-dctl-trio', heading: 'Get 3 Free DCTLs', button: 'Email my three tools',
    features: [['Checker (shown)', 'Judge your shot’s exposure and skin tone.'], ['Exposure/Chart™', 'Build and test looks.'], ['Chart/Tool™', 'Generate reference charts.']] },
  checker: { tag: 'checker', heading: 'Get our Checker DCTL Free', button: 'Email me Checker',
    features: [['Exposure (shown)', 'Judge scene exposure (measured in stops)'], ['Skin hue', 'Spot red or yellow skin shifts.'], ['Levels', 'Find out-of-range values.']] },
});
const EXCLUDES = ['/cart', '/checkout', '/checkouts', '/collections/free-tools', '/products/checker-dctl-plug-in',
  '/products/exposure-chart-dctl-plug-in', '/products/chart-tool-dctl-plug-in', '/products/pq-tester-dctl-plug-in', '/pages/black-friday', '/pages/early-access'];
const CONSENT = '#Avada-CookiesBar .Avada-CookiesBar_Container,.Avada-CookieBar__PreferencePopup,.Avada-CookiesBar-Preferences__PopUp,.Avada-CookiesBar__PreferencesCard';
const CART_INTERACTION = 'pt_free_dctl_cart_interacted_v1';
// Preserve intent across controller remounts even when sessionStorage is denied.
const cartTabs = new WeakSet();
export function readStorage(storage, key) { try { return storage?.getItem(key); } catch { return null; } }
export function writeStorage(storage, key, value) { try { storage?.setItem(key, value); return storage?.getItem(key) === value; } catch { return false; } }
export function chooseOffer(local, session, random = Math.random) {
  const saved = [readStorage(local, EXPERIMENT), readStorage(session, EXPERIMENT)].find(value => Object.hasOwn(OFFERS, value));
  const value = Object.hasOwn(OFFERS, saved) ? saved : random() < .5 ? 'trio' : 'checker';
  writeStorage(local, EXPERIMENT, value);
  writeStorage(session, EXPERIMENT, value);
  return value;
}
export function channelFor(href, referrer) {
  const u = new URL(href); const medium = (u.searchParams.get('utm_medium') || '').toLowerCase();
  const source = (u.searchParams.get('utm_source') || '').toLowerCase();
  if (medium === 'email' || source.includes('omnisend') || u.searchParams.has('omnisendContactID')) return 'email';
  if (['cpc', 'paid', 'paid_social'].includes(medium)) return 'paid';
  let host = ''; try { const r = new URL(referrer); if (r.hostname !== u.hostname) host = r.hostname; } catch { /* direct */ }
  if (medium === 'social' || /(^|\.)(facebook|instagram|reddit|tiktok|linkedin|pinterest|twitter|x)\.com$/.test(host)) return 'social';
  if (/(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.com|ecosia\.org)$/.test(host)) return 'search';
  if ([...u.searchParams.keys()].some(k => k.startsWith('utm_'))) return 'other';
  return host ? 'referral' : 'direct';
}
export function isEligible({ href, cookie = '', signedUp, emailVisit, lastShown, capDays, now = Date.now() }) {
  const u = new URL(href); const path = (u.pathname + u.search).toLowerCase();
  return !EXCLUDES.some(x => path.includes(x)) && !signedUp && !emailVisit &&
    !/(?:^|;\s*)omnisendContactID=/i.test(cookie) &&
    ![...u.searchParams.keys()].some(k => k.toLowerCase() === 'omnisendcontactid') &&
    !(Number(lastShown) > 0 && now - Number(lastShown) < capDays * 86400000);
}
export function safeRecovery(value) {
  try { const u = new URL(value); return u.protocol === 'https:' &&
    ['pixeltoolspost.com', 'get.pixeltoolspost.com', 'download.pixeltoolspost.com', 'link.pixeltoolspost.com'].includes(u.hostname) && !u.username && !u.password ? u.href : null; } catch { return null; }
}
export function errorReason(status, code) {
  if (code === 'turnstile_failed') return 'turnstile_failed';
  if (status === 429) return 'rate_limited';
  return status >= 500 ? 'server' : 'invalid';
}

export function startFreePopup(doc = document, win = window) {
  const dialog = doc.querySelector('[data-pt-free-popup]');
  if (!dialog || win.__ptFreePopupMounted || typeof dialog.showModal !== 'function') return;
  win.__ptFreePopupMounted = true;
  let local, session; try { local = win.localStorage; } catch { /* privacy mode */ }
  try { session = win.sessionStorage; } catch { /* privacy mode */ }
  const params = new URL(win.location.href).searchParams;
  // Explicit preview links exercise the REAL signup and CAPTCHA, but never enter experiment metrics.
  const previewArm = params.get('pt_offer_preview');
  const preview = Object.hasOwn(OFFERS, previewArm);
  const variant = preview ? previewArm : chooseOffer(local, session);
  const offer = OFFERS[variant];
  const coarse = win.matchMedia('(pointer: coarse)').matches;
  const device = coarse ? 'mobile' : 'desktop';
  const capDays = coarse ? 14 : 7;
  const arrivalChannel = channelFor(win.location.href, doc.referrer);
  const channel = readStorage(session, 'pt_popup_channel') || arrivalChannel;
  writeStorage(session, 'pt_popup_channel', channel);
  if (arrivalChannel === 'email') writeStorage(session, 'pt_from_omnisend', '1');
  const source = 'trio_flyout';
  // API origin is fixed: an editor/DOM change must not redirect submitted PII.
  const api = 'https://api.pixeltoolspost.com';
  dialog.dataset.variant = variant;
  dialog.dataset.experiment = EXPERIMENT;
  dialog.dataset.preview = String(preview);
  dialog.querySelector('[data-copy=heading]').textContent = offer.heading;
  const features = doc.createElement('dl');
  for (const [title, description] of offer.features) {
    const dt = doc.createElement('dt'); dt.textContent = title; const dd = doc.createElement('dd'); dd.textContent = description;
    features.append(dt, dd);
  }
  dialog.querySelector('[data-copy=features]').replaceChildren(features);
  const form = dialog.querySelector('[data-signup]');
  const submit = dialog.querySelector('[data-submit]');
  const error = dialog.querySelector('[data-error]');
  const retry = dialog.querySelector('[data-retry]');
  const verification = dialog.querySelector('[data-verification]');
  const statusButton = doc.querySelector('[data-pt-free-status]');
  submit.textContent = offer.button;
  let shown = false, sending = false, completed = false, closing = false, widgetID, opener;
  let token = '', tokenTime = 0, widgetLoading = false, verificationGeneration = 0, deadline, poll, closeTimer, lastErrorReason;
  let waiting = false, interacted = false, destroyed = false, suspended = false, failures = 0;
  let scriptPoll, challengeTimer, retryTimer, waitTimer, scriptCleanup, requestController;
  let cartInteracted = cartTabs.has(win) || readStorage(session, CART_INTERACTION) === '1';
  if (cartInteracted) cartTabs.add(win);
  let ssOpened = false, statusOwned = false, pendingCartFocus;
  const canVerify = () => !destroyed && !suspended && dialog.open && !closing && !sending && !completed && !foregroundOpen();
  const listeners = [];
  function on(target, name, handler, options) { target.addEventListener(name, handler, options); listeners.push(() => target.removeEventListener(name, handler, options)); }
  function track(event, dim = '') {
    if (preview) return;
    const body = JSON.stringify({ source, tag: offer.tag, event, dim, device, channel });
    try { win.fetch(api + '/public/popup-event', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body, keepalive: true, credentials: 'omit' }).catch(() => {}); } catch { /* analytics must not block signup */ }
    try { win.fathom?.trackEvent('Free DCTL popup ' + variant + ' ' + event); } catch { /* optional */ }
  }
  function showError(message, reason) { lastErrorReason = reason; error.textContent = message; error.hidden = false; if (reason) track('error', reason); }
  function clearError() { lastErrorReason = undefined; error.hidden = true; error.textContent = ''; }
  function isCartDrawer(el) { return el?.matches?.('cart-drawer, #cart-drawer'); }
  function nativeCartApi() {
    try { return win.SectionStoreCart; } catch { return undefined; }
  }
  function cartDrawerOpen() {
    try { if (nativeCartApi()?.isOpen?.() === true) return true; } catch { /* Fall back to current public DOM. */ }
    if (ssOpened || doc.querySelector('cart-drawer[open], #cart-drawer[open]')) return true;
    // Hosts and their open shadow roots may be replaced during section rendering.
    return [...doc.querySelectorAll('section-store--cart-block')].some(host =>
      host.shadowRoot?.querySelector('.body.is-open, aside.cart-drawer[role="dialog"][aria-hidden="false"]'));
  }
  function foregroundOpen() {
    return cartDrawerOpen() || [...doc.querySelectorAll('dialog[open], [role="dialog"][open]')].some(el => el !== dialog);
  }
  function stopAcquisition() {
    win.clearInterval(poll); poll = undefined;
  }
  function noteCartInteraction() {
    stopAcquisition();
    if (cartInteracted) return;
    cartInteracted = true; cartTabs.add(win);
    if (readStorage(session, CART_INTERACTION) !== '1') writeStorage(session, CART_INTERACTION, '1');
  }
  function updateStatusAccess() {
    if (!statusButton) return;
    statusButton.hidden = destroyed || suspended || dialog.open || foregroundOpen() || !statusOwned;
    statusButton.textContent = sending || completed ? 'View signup status' : 'Continue signup';
  }
  function reconcileForeground() {
    if (destroyed || suspended) return;
    if (!cartInteracted && (cartTabs.has(win) || readStorage(session, CART_INTERACTION) === '1' || cartDrawerOpen())) noteCartInteraction();
    if (foregroundOpen()) yieldToForeground();
    handoffCartFocus(); updateStatusAccess();
  }
  function cartIntent() {
    noteCartInteraction(); yieldToForeground(); updateStatusAccess();
  }
  function cartRoute(value, suffix = '') {
    try {
      const url = new URL(value, win.location.href);
      const root = new URL(win.Shopify?.routes?.root || '/', win.location.href);
      return url.origin === win.location.origin &&
        [new URL('cart' + suffix, root).pathname, '/cart' + suffix].includes(url.pathname.replace(/\/$/, ''));
    } catch { return false; }
  }
  function activeFocus() {
    let active = doc.activeElement;
    while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
    return active;
  }
  function foregroundOwnsFocus(active) {
    // Follow shadow hosts as well as light-DOM ancestors.
    for (let el = active; el; el = el.parentElement || el.getRootNode()?.host) {
      if (el !== dialog && el.matches?.('cart-drawer[open], #cart-drawer[open], dialog[open], [role="dialog"][open]')) return true;
      if (el.matches?.('section-store--cart-block') &&
        el.shadowRoot?.querySelector('.body.is-open, aside.cart-drawer[role="dialog"][aria-hidden="false"]')) return true;
    }
    return false;
  }
  function handoffCartFocus() {
    if (!pendingCartFocus || destroyed || suspended || dialog.open) return;
    const active = activeFocus();
    if (foregroundOwnsFocus(active) || (active !== pendingCartFocus && active !== doc.body &&
      active !== doc.documentElement && !dialog.contains(active))) { pendingCartFocus = undefined; return; }
    // Public SS markup has both an overlay and a button with data-cart-close.
    // Only the confirmed button inside an actually open drawer is a focus target.
    for (const host of doc.querySelectorAll('section-store--cart-block')) {
      const root = host.shadowRoot;
      if (!root?.querySelector('.body.is-open, aside.cart-drawer[role="dialog"][aria-hidden="false"]')) continue;
      const target = root.querySelector('aside.cart-drawer[role="dialog"] button[data-cart-close].cart-close');
      if (!target || target.matches(':disabled') || target.closest('[hidden], [inert], [aria-hidden="true"]')) continue;
      target.focus(); pendingCartFocus = undefined; return;
    }
  }
  // Native close may restore BODY/an opener behind the cart. Retain an existing
  // foreground owner; otherwise hand off only focus yielded by this popup.
  function closeDialog(restoreOpener = false) {
    const active = activeFocus();
    const owned = foregroundOwnsFocus(active);
    dialog.close();
    if (owned && active.isConnected) { if (activeFocus() !== active) active.focus(); }
    else if (restoreOpener && !foregroundOpen()) opener?.focus?.();
    else if (!destroyed && !suspended) {
      pendingCartFocus = activeFocus(); handoffCartFocus();
      // Cart intent/opened can precede synchronous render. A later async opened
      // event also reconciles this pending handoff without polling or observing.
      win.queueMicrotask(handoffCartFocus);
    }
  }
  function releaseWait() {
    waiting = false; win.clearTimeout(waitTimer);
    submit.disabled = false; submit.textContent = offer.button; form.removeAttribute('aria-busy');
  }
  function stopVerification() {
    verificationGeneration++; token = ''; tokenTime = 0; widgetLoading = false;
    win.clearTimeout(scriptPoll); win.clearTimeout(challengeTimer); win.clearTimeout(retryTimer);
    scriptCleanup?.(); scriptCleanup = undefined; retryTimer = undefined;
    const id = widgetID; widgetID = undefined;
    if (id !== undefined) { try { win.turnstile?.remove(id); } catch { /* detached widget */ } }
    verification.replaceChildren();
  }
  function verificationUnavailable() {
    stopVerification(); releaseWait(); retry.hidden = false;
    // A verification refresh must never erase server/rate-limit/inbox guidance.
    if (!lastErrorReason || lastErrorReason === 'turnstile_failed') {
      showError('Verification couldn’t finish. Please retry, or contact us for help.', 'turnstile_failed');
      const contact = doc.createElement('a'); contact.href = 'mailto:info@pixeltoolspost.com'; contact.textContent = 'Contact us';
      error.append(' ', contact);
    }
  }
  function verificationFailed() {
    stopVerification();
    if (!canVerify()) return;
    // One retry owner: disable Turnstile auto retry/refresh and bound this flow
    // to three backoffs (1s, 2s, 4s). Interaction cannot bypass the backoff.
    if (failures >= 3) { verificationUnavailable(); return; }
    const delay = 1000 * 2 ** failures++;
    retryTimer = win.setTimeout(() => { retryTimer = undefined; loadVerification(); }, delay);
  }
  function loadVerification() {
    if (!canVerify() || widgetLoading || token || retryTimer !== undefined) return;
    widgetLoading = true; retry.hidden = true;
    const generation = ++verificationGeneration;
    const current = () => generation === verificationGeneration && canVerify();
    function renderWhenReady() {
      if (!current()) return;
      if (!win.turnstile?.render) {
        scriptPoll = win.setTimeout(renderWhenReady, 100); return;
      }
      win.clearTimeout(challengeTimer);
      // Also bound silent challenges that never call any completion callback.
      challengeTimer = win.setTimeout(() => { if (current()) verificationFailed(); }, 20000);
      let received = false;
      try {
        const id = win.turnstile.render(verification, {
          sitekey: dialog.dataset.sitekey, action: 'signup', theme: 'light', appearance: 'interaction-only',
          size: 'compact', retry: 'never', 'refresh-expired': 'never', 'refresh-timeout': 'never',
          callback: value => {
            if (!current() || received || typeof value !== 'string' || !value) return;
            failures = 0;
            received = true; token = value; tokenTime = Date.now(); widgetLoading = false;
            win.clearTimeout(challengeTimer); retry.hidden = true;
            if (lastErrorReason === 'turnstile_failed') clearError();
            if (waiting) submitSignup();
          },
          'expired-callback': () => { if (current()) verificationFailed(); },
          'error-callback': () => { if (current()) verificationFailed(); return true; },
          'timeout-callback': () => { if (current()) verificationFailed(); },
        });
        // render() may call back synchronously; never retain its invalidated ID.
        if (current()) widgetID = id;
        else { try { win.turnstile.remove(id); } catch { /* detached widget */ } }
      } catch { if (current()) verificationFailed(); }
    }
    challengeTimer = win.setTimeout(() => { if (current()) verificationFailed(); }, 12000);
    if (!win.turnstile?.render && !doc.querySelector('script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]')) {
      const script = doc.createElement('script'); script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true; script.defer = true; script.dataset.ptTurnstile = '1';
      const failed = () => { script.remove(); if (current()) verificationFailed(); };
      script.addEventListener('error', failed);
      scriptCleanup = () => { script.removeEventListener('error', failed); if (!win.turnstile?.render) script.remove(); };
      doc.head.append(script);
    }
    renderWhenReady();
  }
  function interact() {
    if (!canVerify()) return;
    interacted = true;
    // Exhaustion requires a deliberate retry or submit, not keystrokes/online storms.
    if (!retry.hidden) return;
    loadVerification();
  }
  on(form, 'focusin', interact); on(form, 'input', interact); on(form, 'pointerdown', interact);
  on(retry, 'click', () => {
    if (!canVerify() || retry.hidden) return;
    stopVerification(); failures = 0;
    if (lastErrorReason === 'turnstile_failed') clearError();
    loadVerification();
  });
  on(win, 'online', () => { if (interacted && retry.hidden) loadVerification(); });
  on(doc, 'visibilitychange', () => { if (!doc.hidden && interacted && retry.hidden) loadVerification(); });
  function rendered(el) {
    if (!el.isConnected || !el.getClientRects().length) return false;
    for (let node = el; node; node = node.parentElement) {
      const s = win.getComputedStyle(node);
      if (node.hidden || node.hasAttribute('inert') || node.getAttribute('aria-hidden') === 'true' ||
          s.visibility === 'hidden' || s.display === 'none' || Number(s.opacity) === 0) return false;
    }
    return true;
  }
  function eligible() {
    return preview || isEligible({ href: win.location.href, cookie: doc.cookie,
      signedUp: readStorage(local, 'pt_signup_done') || readStorage(session, 'pt_signup_done'),
      emailVisit: arrivalChannel === 'email' || readStorage(session, 'pt_from_omnisend'),
      lastShown: readStorage(local, 'pt_free_popup_shown') || readStorage(session, 'pt_free_popup_shown') || readStorage(local, 'pt_autoopen_free-dctl-trio'), capDays });
  }
  function open(trigger) {
    if (destroyed || suspended || cartInteracted) return;
    reconcileForeground();
    if (shown || closing || cartInteracted || doc.hidden || !eligible() || doc.querySelector('dialog[open]') || foregroundOpen() ||
      (!preview && doc.querySelector('dialog.fts-dialog[data-pt-form="demo"]')) || [...doc.querySelectorAll(CONSENT)].some(rendered)) return;
    opener = doc.activeElement;
    try { dialog.showModal(); } catch { return; }
    shown = true; dialog.dataset.trigger = trigger;
    stopAcquisition();
    if (!preview) {
      const now = String(Date.now()); writeStorage(local, 'pt_free_popup_shown', now); writeStorage(session, 'pt_free_popup_shown', now);
    }
    track('view', 'auto');
  }
  function close(method) {
    if (!dialog.open || closing) return;
    // A pending request may finish with a recovery link. Keep its result reachable
    // without reopening a popup the visitor deliberately dismissed.
    statusOwned = sending || waiting;
    stopVerification(); if (waiting) releaseWait();
    closing = true; track('dismiss', method); dialog.classList.add('is-closing');
    const finish = () => { if (!dialog.open) return; closeDialog(true); dialog.classList.remove('is-closing'); closing = false; updateStatusAccess(); };
    closeTimer = win.setTimeout(finish, win.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220);
  }
  function yieldToForeground() {
    if (dialog.open) {
      // Explicit dismissal retains its own pending-only status ownership.
      if (!closing) statusOwned = interacted || sending || waiting || completed;
      stopVerification(); if (waiting) releaseWait();
      win.clearTimeout(closeTimer); closing = false;
      dialog.classList.remove('is-closing'); closeDialog();
    }
    // Also hide a pending request's chip when the popup was already closed.
    updateStatusAccess();
  }
  on(dialog.querySelector('[data-close]'), 'click', () => close('close_button'));
  if (statusButton) on(statusButton, 'click', () => {
    if (destroyed || suspended) return;
    reconcileForeground();
    if (!statusOwned || dialog.open || closing || doc.querySelector('dialog[open]') || foregroundOpen()) return;
    dialog.showModal(); statusButton.hidden = true;
    if (completed) dialog.querySelector('[data-success]').focus();
    else if (interacted && !sending) { failures = 0; loadVerification(); }
  });
  on(dialog, 'close', () => { if (!dialog.open) { stopVerification(); if (waiting) releaseWait(); } });
  on(dialog, 'cancel', e => { e.preventDefault(); close('esc'); });
  on(dialog, 'click', e => {
    if (e.target !== dialog) return; const r = dialog.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close('backdrop');
  });
  // Window capture runs before SS's document capture listeners stop propagation.
  on(win, 'click', e => {
    const control = e.composedPath().find(el => el?.matches?.('[aria-controls="cart-drawer"]'));
    if (!control) return;
    const target = doc.getElementById('cart-drawer');
    if (isCartDrawer(target) || (!target && control.matches('a[href]') && cartRoute(control.href))) cartIntent();
  }, true);
  on(win, 'submit', e => {
    const cartForm = e.composedPath().find(el => el?.matches?.('form'));
    if (!cartForm || cartForm === form) return;
    // An explicit empty action submits to the document URL, regardless of <base>.
    const override = e.submitter?.hasAttribute('formaction') ? e.submitter.getAttribute('formaction') : null;
    try {
      const effectiveAction = override === null ? cartForm.action : override === '' ? cartForm.ownerDocument.URL : new URL(override, cartForm.baseURI).href;
      if (cartRoute(effectiveAction, '/add') || cartRoute(effectiveAction, '/add.js')) cartIntent();
    } catch { /* An invalid effective action is not a known cart route. */ }
  }, true);
  on(doc, 'toggle', e => {
    const surface = e.target;
    if (surface !== dialog && (isCartDrawer(surface) || surface?.matches?.('dialog, [role="dialog"]'))) {
      if (isCartDrawer(surface) && surface.hasAttribute('open')) noteCartInteraction();
      reconcileForeground();
    }
  }, true); // Native toggle does not bubble.
  on(doc, 'cart:prepare-bundled-sections', cartIntent);
  on(doc, 'variant:add', cartIntent);
  function afterCartRender() {
    win.queueMicrotask(() => {
      if (destroyed || suspended) return;
      ssOpened = false; reconcileForeground();
    });
  }
  let nativeCartBinding;
  function unbindNativeCart() {
    const old = nativeCartBinding; nativeCartBinding = undefined;
    try { old?.unsubscribe?.(); } catch { /* A replaced API must not block teardown. */ }
  }
  function bindNativeCart() {
    const api = nativeCartApi();
    if (nativeCartBinding?.api === api) return;
    unbindNativeCart();
    if (!api) return;
    const binding = { api }; nativeCartBinding = binding;
    const current = () => !destroyed && !suspended && nativeCartBinding === binding && nativeCartApi() === api;
    try {
      const unsubscribe = api.onBeforeOpen?.(() => {
        if (!current()) return;
        // Yield synchronously, before SS renders or moves focus; never veto cart.
        ssOpened = true; cartIntent();
        win.queueMicrotask(() => {
          if (!current()) return;
          // A later hook can veto without emitting opened/closed. Actual API/DOM
          // state then restores only recovery already owned by the signup flow.
          ssOpened = false; reconcileForeground();
        });
      });
      if (typeof unsubscribe === 'function') binding.unsubscribe = unsubscribe;
    } catch { /* Missing/throwing hooks retain opened and public DOM fallbacks. */ }
  }
  on(win, 'section-store:cart:opened', () => {
    // The event can precede render: latch foreground ownership synchronously.
    ssOpened = true; noteCartInteraction(); reconcileForeground(); afterCartRender();
  });
  on(win, 'section-store:cart:closed', () => {
    pendingCartFocus = undefined; ssOpened = false; reconcileForeground();
    // Recheck after the synchronous SS render if its event arrived first.
    afterCartRender();
  });
  on(win, 'section-store:cart:item-added', cartIntent);
  // Readiness only binds/reconciles actual state; it is not purchase intent.
  on(win, 'section-store:cart:ready', () => { bindNativeCart(); reconcileForeground(); afterCartRender(); });
  on(win, 'section-store:cart:updated', afterCartRender);
  bindNativeCart();
  reconcileForeground();
  function validInputs() {
    const first = form.elements.firstName; const email = form.elements.email;
    first.value = first.value.trim(); email.value = email.value.trim();
    if (!form.checkValidity()) { form.reportValidity(); track('error', 'validation'); return false; }
    return true;
  }
  on(form, 'submit', e => {
    e.preventDefault(); if (!canVerify() || waiting) return;
    clearError(); if (!validInputs()) return;
    interacted = true;
    if (token && Date.now() - tokenTime >= 290000) stopVerification();
    if (token) { submitSignup(); return; }
    waiting = true; submit.disabled = true; submit.textContent = 'Verifying…'; form.setAttribute('aria-busy', 'true');
    // Revalidate current fields on token arrival. Dismissal cancels this intent.
    waitTimer = win.setTimeout(() => { if (waiting && canVerify()) verificationUnavailable(); }, 45000);
    if (!retry.hidden) { stopVerification(); failures = 0; }
    loadVerification();
  });
  async function submitSignup() {
    if (!canVerify() || !token) return;
    if (!validInputs()) { releaseWait(); return; }
    releaseWait();
    const first = form.elements.firstName; const email = form.elements.email;
    sending = true; submit.disabled = true; submit.textContent = 'Sending…'; form.setAttribute('aria-busy', 'true');
    track('submit');
    const body = { firstName: first.value, lastName: '', email: email.value, tag: offer.tag, marketingConsent: true, turnstileToken: token };
    if (!preview) Object.assign(body, { popupSource: source, device, channel });
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) if (params.get(key)) body[key] = params.get(key).slice(0, 200);
    stopVerification(); const controller = new win.AbortController(); requestController = controller;
    deadline = win.setTimeout(() => controller.abort(), 20000);
    try {
      const response = await win.fetch(api + '/public/subscribe', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: controller.signal });
      const data = await response.json();
      if (destroyed) return;
      if (!response.ok || data.success !== true) {
        const reason = errorReason(response.status, data.error);
        showError(reason === 'rate_limited' ? 'Please wait a few minutes before trying again.' : reason === 'turnstile_failed' ? 'Verification expired. Please verify again and retry.' : 'We couldn’t complete your signup. Please try again shortly.', reason);
        return;
      }
      completed = true;
      if (!preview) { writeStorage(local, 'pt_signup_done', '1'); writeStorage(session, 'pt_signup_done', '1'); }
      form.hidden = true;
      const success = dialog.querySelector('[data-success]'); success.hidden = false;
      const recovery = safeRecovery(data.downloadUrl);
      if (recovery) {
        dialog.querySelector('[data-success-copy]').textContent = 'Your signup was accepted, but email delivery isn’t confirmed. Use the link below to get your tools, or contact us for help.';
        const link = dialog.querySelector('[data-recovery]'); link.href = recovery; link.hidden = false;
      }
      if (dialog.open && !closing && !suspended && !foregroundOpen()) success.focus();
    } catch (err) {
      if (destroyed) return;
      showError(err.name === 'AbortError' ? 'That took longer than expected. Check your inbox before trying again.' : 'We couldn’t confirm the response. Check your inbox, then retry if needed.', err.name === 'AbortError' ? 'timeout' : 'network');
    } finally {
      win.clearTimeout(deadline); requestController = undefined;
      if (destroyed) return;
      sending = false; submit.disabled = false; submit.textContent = offer.button; form.removeAttribute('aria-busy');
      if (!completed) { failures = 0; retry.hidden = false; }
      updateStatusAccess();
    }
  }
  const started = Date.now(); const delay = Math.min(30, Math.max(3, Number(dialog.dataset.delay) || 6)) * 1000;
  if (!cartInteracted) poll = win.setInterval(() => { if (Date.now() - started >= delay) open('timer'); }, 250);
  // Exit intent is desktop-only. Timer and exit share the same once-only open guard.
  if (win.matchMedia('(hover: hover) and (pointer: fine)').matches) on(doc, 'mouseout', e => {
    if (!e.relatedTarget && e.clientY <= 0) open('exit');
  });
  on(win, 'pagehide', () => {
    suspended = true; pendingCartFocus = undefined; stopVerification(); if (waiting) releaseWait();
    stopAcquisition(); win.clearTimeout(closeTimer);
    if (closing) { closeDialog(); dialog.classList.remove('is-closing'); closing = false; }
    updateStatusAccess();
  });
  on(win, 'pageshow', e => {
    suspended = false;
    // A frozen page can miss lifecycle events; current DOM and tab storage win.
    if (e.persisted) ssOpened = false;
    reconcileForeground();
    if (e.persisted && cartInteracted) yieldToForeground();
    if (e.persisted && interacted && retry.hidden) loadVerification();
    if (e.persisted && !shown && !cartInteracted && poll === undefined) poll = win.setInterval(() => { if (Date.now() - started >= delay) open('timer'); }, 250);
  });
  // Account for phone keyboards and rotation without remounting the form/widget
  // or losing the visitor's input. Pinch zoom keeps the normal layout viewport.
  if (win.visualViewport) {
    const fitViewport = () => {
      if (win.visualViewport.scale === 1) {
        dialog.style.setProperty('--pt-free-viewport-height', win.visualViewport.height + 'px');
        const bottomInset = Math.max(0, doc.documentElement.clientHeight - win.visualViewport.height - win.visualViewport.offsetTop);
        dialog.style.setProperty('--pt-free-viewport-bottom', bottomInset + 'px');
      } else {
        dialog.style.removeProperty('--pt-free-viewport-height');
        dialog.style.removeProperty('--pt-free-viewport-bottom');
      }
    };
    fitViewport(); on(win.visualViewport, 'resize', fitViewport); on(win.visualViewport, 'scroll', fitViewport);
  }
  return { variant, preview, destroy() { destroyed = true; pendingCartFocus = undefined; unbindNativeCart(); listeners.forEach(remove => remove()); stopAcquisition(); win.clearTimeout(closeTimer); win.clearTimeout(deadline); stopVerification(); releaseWait(); requestController?.abort(); if (dialog.open) dialog.close(); updateStatusAccess(); win.__ptFreePopupMounted = false; } };
}
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => startFreePopup(), { once: true });
  else startFreePopup();
}
